<template>
  <div>
    <div class="box box-primary">
      <div class="box-header with-border">
        <h3 class="box-title">{{$t('mail_box.compose.compose_new_message')}}</h3>
        <!-- <input type="checkbox" :name="p.permission_code" @change="onChange(p)" v-model="p.enabled"  > -->
      </div>
      <!-- /.box-header -->
      <b-form class="form-horizontal">
        <div class="box-body">
          <!-- TO -->
          <div class="form-group">
            <label for="subject" class="col-md-2 control-label required" style="padding-top:0px">
              <button
                type="button"
                class="btn btn-labeled btn-primary"
                style="margin-right: 5px;"
                @click="doOpenUser('TO')"
              >
                <span class="btn-label">
                  <i class="fa fa-envelope-o"></i>
                </span>
                {{$t('mail_box.compose.to')}}
              </button>
            </label>

            <div class="col-md-10">
              <vue-input-tag v-model="email_info.to" validate="email"></vue-input-tag>
              <p class="email_default show_email email_activated">{{(email_info.to.length)}}</p>
              <!-- <b-form-input
                v-model="email_info.to"
                type="text"
                required
                class="form-control"
                id="to"
                :placeholder="$t('mail_box.compose.to')"
              />-->
            </div>
          </div>

          <!-- BCC -->
          <div class="form-group">
            <label for="subject" class="col-md-2 control-label required" style="padding-top:0px">
              <button
                type="button"
                class="btn btn-labeled btn-primary"
                style="margin-right: 5px;"
                @click="doOpenUser('BCC')"
              >
                <span class="btn-label">
                  <i class="fa fa-envelope-o"></i>
                </span>
                {{$t('mail_box.compose.bcc')}}
              </button>
            </label>

            <div class="col-md-10">
              <vue-input-tag v-model="email_info.bcc" validate="email"></vue-input-tag>
            </div>
          </div>

          <div class="form-group">
            <label
              for="subject"
              class="col-md-2 control-label required"
            >{{$t('mail_box.compose.titile')}}</label>
            <div class="col-md-10">
              <b-form-input
                v-model="email_info.subject"
                type="text"
                required
                class="form-control"
                id="subject"
                :placeholder="$t('mail_box.compose.titile')"
              />
            </div>
          </div>

          <div class="form-group">
            <label
              for="subject"
              class="col-md-2 control-label required"
            >{{$t('mail_box.compose.content')}}</label>
            <div class="col-md-12">
              <trumbowyg
                v-model="email_info.content"
                :config="config"
                class="form-control"
                name="content"
              ></trumbowyg>
            </div>
          </div>

          <!-- <div class="container">
            <div class="large-12 medium-12 small-12 cell">
              <label>Files
                <input type="file" id="files" ref="files" multiple v-on:change="handleFilesUpload()"/>
              </label>
              <button v-on:click="submitFiles()">Submit</button>
            </div>
          </div>-->
          <div class="form-group">
            <div class="col-md-12">
              <div class="btn btn-default btn-file">
                <i class="fa fa-paperclip"></i>
                {{$t('mail_box.compose.attach')}}
                <input
                  type="file"
                  id="files"
                  name="attachment"
                  ref="files"
                  multiple
                  v-on:change="handleFilesUpload()"
                  @click="$refs.files.value=null"
                />
              </div>
            </div>
            <!-- <p class="help-block">Max. 32MB</p> -->
          </div>

          <div class="form-group">
            <div class="col-md-12">
              <div v-for="(file, key) in email_info.files" :key="file.name" class="file-listing">
                <span class="name-file">{{ file.name }}</span> -
                <span class="size-file">{{readFileSize(file.size)}}</span>
                <span class="remove-file" v-on:click="removeFile( key )">Remove</span>
              </div>
            </div>
          </div>
        </div>
        <!-- /.box-body -->
        <div class="box-footer">
          <!-- <button type="button" class="btn btn-default">
            <i class="fa fa-pencil"></i> Draft
          </button>-->

          <button
            type="button"
            class="btn btn-labeled btn-danger"
            @click="doCancel"
            style="margin-right: 5px; background-color: #f29911;border-color: #f29911;"
          >
            <span class="btn-label">
              <i class="fa fa-mail-reply"></i>
            </span>
            {{$t('common.back')}}
          </button>

          <button
            type="button"
            class="btn btn-labeled btn-primary pull-right"
            style="margin-right: 5px;"
            @click="sendMail"
          >
            <span class="btn-label">
              <i class="fa fa-envelope-o"></i>
            </span>
            {{$t('common.send_mail')}}
          </button>
        </div>
        <!-- <button type="reset" class="btn btn-default">
          <i class="fa fa-times"></i> Discard
        </button>-->
        <!-- /.box-footer -->
      </b-form>
    </div>
    <!-- /. box -->

    <lte-core-alert v-for="snackbar in GET_SNACK_BAR" :key="snackbar.id" :item="snackbar"></lte-core-alert>
    <loading :active.sync="isLoading" :can-cancel="false" color="#1E90FF"></loading>
    <select-user-modal id="modal-select-user" ref="modalSelectUser" :userId="1" @doSelectEmail="doSelectEmail" />
    <router-view></router-view>
  </div>
</template>
<script>
import LTECoreAlert from "@/components/LTESnackBar.vue";
import Loading from "vue-loading-overlay";
import { mapGetters, mapActions } from "vuex";
import SelectUserModal from "@/components/SelectUserModal.vue";
import constantsData from '@/lib/constantsData';

// Import this component
import Trumbowyg from "vue-trumbowyg";

// Import editor css
import "trumbowyg/dist/ui/trumbowyg.css";

// import i18n from "../../lang";
import utils from '@/lib/utils';

// vue-input-tag
import InputTag from "vue-input-tag";

export default {
  name: "Compose",
  data() {
    return {
      isLoading: false,
      email_info: {
        to: [],
        bcc: [],
        subject: "",
        content: null,
        files: []
      },
      fileNames: [],

      config: {
        // Get options from
        // https://alex-d.github.io/Trumbowyg/documentation
      },
    };
  },
  watch: {},
  computed: {
    ...mapGetters([
      "GET_SNACK_BAR",
      "PAGINATION",
      "PAGINATOR",
      "PAGE_ARROW"
    ])
  },

  methods: {
    readFileSize(size) {
      if (size < 1024) return size + " B";
      let i = Math.floor(Math.log(size) / Math.log(1024));
      let num = size / Math.pow(1024, i);
      let round = Math.round(num);
      num = round < 10 ? num.toFixed(2) : round < 100 ? num.toFixed(1) : round;
      return `${num} ${"KMGTPEZY"[i - 1]}B`;
    },

    /*
        Handles the uploading of files
    */
    handleFilesUpload() {
      let fileName = this.$refs.files.files[0].name
      let match = (new RegExp('[@!#$%^&*<>?/}{~:ÀÁÂÃÈÉÊÌÍÒÓÔÕÙÚĂĐĨŨƠàáâãèéêìíòóôõùúăđĩũơƯĂẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼỀỀỂưăạảấầẩẫậắằẳẵặẹẻẽềềểỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪễệỉịọỏốồổỗộớờởỡợụủứừỬỮỰỲỴÝỶỸửữựỳỵỷỹ]')).test(fileName)
      if (match)
      {
        this.ON_SHOW_TOAST({
            message: 'Tên file đính kèm không được viết bằng tiếng Việt có dấu, không chứa ký tự đặc biệt, vui lòng đổi lại tên và thực hiện lại',
            styleType: "danger"
          });
      }
      else
      {
        let fileNameExist = "";
        let filesize = this.$refs.files.files[0].size
        if(filesize >  constantsData.emailConfigure.max_file_size_attach.size)
        {
          this.ON_SHOW_TOAST({
              message: 'Tập tin không vượt quá ' + constantsData.emailConfigure.max_file_size_attach.text,
              styleType: "danger"
            })
        }
        else{
          let uploadedFiles = this.$refs.files.files;
        /*
            Adds the uploaded file to the files array
        */

          for (var i = 0; i < uploadedFiles.length; i++) {
            let fileName = uploadedFiles[i].name;

            if (!this.fileNames.includes(fileName)) {
              this.email_info.files.push(uploadedFiles[i]);
              this.fileNames.push(fileName);
            } else {
              fileNameExist += fileName + " ";
            }
          }
        }

        if (fileNameExist != "") {
          this.ON_SHOW_TOAST({
            message: this.$t("mail_box.compose.file_exist", {
              "0": fileNameExist
            }),
            styleType: "danger"
          });
        }
      }
    },

    /*
        Removes a select file the user has uploaded
      */
    removeFile(key) {
      this.email_info.files.splice(key, 1);
      this.fileNames.splice(key,1);
    },

    doSelectEmail(data) {
      if(data.callBackFrom == "TO"){
        this.email_info.to = data.tagsEmail;
      } else if(data.callBackFrom == "BCC"){
        this.email_info.bcc = data.tagsEmail;
      }
    },
    doOpenUser(callBack) {
      this.$refs.modalSelectUser.setCallBackFunction(callBack)
      $("#modal-select-user").modal("show");
    },
    // handleFilesUpload() {
    //   this.email_info.files = this.$refs.files.files;
    // },
    validateData: function() {
      let validatedResult = "OK";

      // #1445: Không cần check nhâp email to
      // if (utils.isNull(this.email_info.to)) {
      //   validatedResult = "Địa Chỉ Email Không Được Trống";
      // }

      if (utils.isNull(this.email_info.subject)) {
        validatedResult = "Tiêu Đề Không Được Trống";
      }

      if (utils.isNull(this.email_info.content)) {
        validatedResult = "Nội Dung Không Được Trống";
      }
      return validatedResult;
    },
    sendMail() {
      let result = this.validateData();
      if (result == "OK") {
        let totalSize = 0
        for (let j = 0, size = this.email_info.files.length; j < size; j++) {
          totalSize += this.email_info.files[j].size
          // 3mb
          if (this.email_info.files[j].size > constantsData.emailConfigure.max_file_size_attach.size) {
            this.ON_SHOW_TOAST({
              message: 'Tập tin không vượt quá ' + constantsData.emailConfigure.max_file_size_attach.text,
              styleType: "danger"
            })
            return;
          }
        }
        // 10mb
        if (totalSize > constantsData.emailConfigure.max_file_size.size) {
          this.ON_SHOW_TOAST({
            message: 'Tổng tập tin không vượt quá ' +  constantsData.emailConfigure.max_file_size.text,
            styleType: "danger"
          })
          return;
        }
        /*
            Initialize the form data
          */
        let formData = new FormData();

        /*
            Iteate over any file sent over appending the files
            to the form data.
          */
        for (var i = 0; i < this.email_info.files.length; i++) {
          let file = this.email_info.files[i];

          formData.append("files[" + i + "]", file);
        }

        formData.append("to", this.email_info.to);
        formData.append("bcc", this.email_info.bcc);
        formData.append("subject", this.email_info.subject);
        formData.append("content", this.email_info.content);

        this.isLoading = true;
        this.SEND_MAIL(formData)
          .then(
            function() {
                this.ON_SHOW_TOAST({
                message: this.$t("mail_box.compose.send_mail_success"),
                styleType: "success"
              });

              this.isLoading = false;

              this.$emit("hideCompose", false);
            }.bind(this)
          )
          .catch(
            function(error) {
              this.ON_SHOW_TOAST({
                message: error.response.data.error,
                styleType: "danger"
              });

              this.isLoading = false;
            }.bind(this)
          );
      } else {
        this.ON_SHOW_TOAST({
          message: result,
          styleType: "danger"
        });
      }
    },

    doCancel() {
      this.$emit("hideCompose", false);
    },

    ...mapActions([
      "ERROR_TOAST",
      "SUCCESS_TOAST",
      "SEND_MAIL",
      "ON_SHOW_TOAST"
    ])
  },
  mounted() {},

  components: {
    Trumbowyg,
    "lte-core-alert": LTECoreAlert,
    loading: Loading,
    "select-user-modal": SelectUserModal,
    "vue-input-tag": InputTag
  }
};
</script>


<style scoped>
input[type="file"] {
  position: absolute;
  top: -500px;
}

div.file-listing {
  width: 300px;
  margin-left: 50px;
}

.name-file {
  font-weight: bold;
}

.size-file {
  margin-left: 10px;
}

span.remove-file {
  color: red;
  cursor: pointer;
  float: right;
}


.email_default {
  padding: 2px 8px;
  position: absolute;
  top: 20px;
  right: 21px;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
  background: #dd4b39;
  color: white;
  border-color: #d73925;
  border-radius: 4px;
  font-size: 13px;
  display: none;
  -webkit-transition: all 0.1s;
  transition: all 0.1s;
}
.show_email {
  display: block !important;
}
.email_activated {
  background: #06a65a;
  color: rgba(255, 255, 255, 0.9);
  font-family:"Glyphicons Halflings"
}


</style>


// WEBPACK FOOTER //
// src/views/Mailbox/Compose.vue